import OrdemServicoAnexoService from "@/services/OrdemServicoAnexoService";

export const ordemServicoAnexo = {
  namespaced: true,
  state: {
    ordemServicoAnexo: {},
  },
  actions: {
    getOrdemServicoAnexo({ commit }, payload) {
      return OrdemServicoAnexoService.GetOrdemServicoAnexo(payload).then(
        (ordemServicoAnexo) => {
          return Promise.resolve(ordemServicoAnexo);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postOrdemServicoAnexo({ commit }, payload) {
      return OrdemServicoAnexoService.PostOrdemServicoAnexo(payload).then(
        (ordemServicoAnexo) => {
          return Promise.resolve(ordemServicoAnexo);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putOrdemServicoAnexo({ commit }, payload) {
      return OrdemServicoAnexoService.PutOrdemServicoAnexo(payload).then(
        (ordemServicoAnexo) => {
          return Promise.resolve(ordemServicoAnexo);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteOrdemServicoAnexo({ commit }, payload) {
      return OrdemServicoAnexoService.DeleteOrdemServicoAnexo(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getOrdemServicoAnexoOData({ commit }, payload) {
      return OrdemServicoAnexoService.GetOrdemServicoAnexoOData(payload).then(
        (ordemServicoAnexo) => {
          return Promise.resolve(ordemServicoAnexo);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default ordemServicoAnexo;
